import { Stack } from "@mantine/core"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { useGetExportRequests } from "~/gen/api"
import { ExportRequestsTable } from "~/pages/Brand/DataTransfer/Export/ExortRequestsTable"

export const DataTransferExport = () => {
  const exportRequestsQuery = useGetExportRequests()

  return (
    <HeaderControlsProvider>
      <Stack>
        <DataFetchWrapper query={exportRequestsQuery}>
          {({ data }) => (
            <ExportRequestsTable data={data.data} total={data.data.length} />
          )}
        </DataFetchWrapper>
      </Stack>
    </HeaderControlsProvider>
  )
}
